// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d8-b";
export var colorBlue = "_d8-8";
export var colorDot = "_d8-0";
export var colorDotLarge = "_d8-2";
export var colorDotSmall = "_d8-1";
export var colorGreen = "_d8-7";
export var colorGrey = "_d8-3";
export var colorOrange = "_d8-5";
export var colorPink = "_d8-a";
export var colorPurple = "_d8-9";
export var colorRed = "_d8-4";
export var colorYellow = "_d8-6";